import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { SettingsEdit } from './settings-edit';

function settingsEditRoute(routeProps: RouteComponentProps) {
  return (
    <Route
      path={`${routeProps.match.path}/edit/:id`}
      render={() => (
        <>
          <SettingsEdit />
        </>
      )}
    />
  );
}

export { settingsEditRoute };
